import { makeObservable, observable } from 'mobx'

import type { DocumentType } from 'modules/documents/store/models/Document'

export class FilesStore {
  files: File[] = []
  type: DocumentType | null | undefined = null

  constructor() {
    makeObservable(this, {
      files: observable,
      type: observable,
    })
  }

  setFiles(files: File[]) {
    this.files = files
  }

  setType(type: DocumentType | null | undefined) {
    this.type = type
  }

  concat(files: File[]) {
    this.files = this.files.concat(files)
  }
}

export default new FilesStore()
